import * as React from 'react';
import { Copy, Check } from 'lucide-react';
import { Input } from '../../../ui/input';
import { Button } from '../../../ui/button';
import { cn } from '../../../../lib/utils';

interface DocumentCopyInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    onCopy?: () => void;
}

export const DocumentCopyInput = React.forwardRef<
    HTMLInputElement,
    DocumentCopyInputProps
>(({ className, value, onCopy, ...props }, ref) => {
    const [copied, setCopied] = React.useState(false);

    const handleCopy = () => {
        if (typeof value === 'string' || typeof value === 'number') {
            navigator.clipboard.writeText(value.toString());
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
            onCopy?.();
        }
    };

    return (
        <div className="flex w-full items-center space-x-2">
            <Input
                className={cn('flex-1', className)}
                ref={ref}
                value={value}
                {...props}
            />
            <Button
                type="button"
                variant="outline"
                size="icon"
                onClick={handleCopy}
                disabled={!value}
                title="Copy to clipboard"
            >
                {copied ? (
                    <Check className="h-4 w-4" />
                ) : (
                    <Copy className="h-4 w-4" />
                )}
            </Button>
        </div>
    );
});
DocumentCopyInput.displayName = 'DocumentCopyInput';
